import { render, staticRenderFns } from "./CandidatesEmpty.vue?vue&type=template&id=8c19f88e&"
import script from "./CandidatesEmpty.vue?vue&type=script&lang=js&"
export * from "./CandidatesEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports